import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import dialogBgImage from "assets/images/dialogBgImage.png";
import { useMediaQuery } from "react-responsive";
import { IconButton, InputAdornment } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { walletDisconnect } from "Store/slices/walletSlice";

function WalletDialog({ openStatus, onClose, postId, type }) {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const { isWeb3Enabled, address, chainId, balance, reward, isWalletLoading } =
    useSelector((state) => state.walletData);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const handleCopy = () => {
    toast.success(`Copied to clipboard`, {
      style: {
        fontSize: "15px",
      },
    });
  };

  const handleWalletDisconnect = () => {
    // window.location.reload();
    dispatch(walletDisconnect());
    onClose();
  };

  return (
    <Dialog
      sx={{}}
      open={openStatus}
      maxWidth="sm"
      fullWidth
      fullScreen={isTabletOrMobile && true}
      onClose={onClose}
    >
      <MDBox
        sx={{
          //   overflow: "auto",
          height: isTabletOrMobile && "1000px",
          border: isDesktopOrLaptop && "1px solid #F2CB2E",
          borderRadius: isDesktopOrLaptop && "8px",
          backgroundColor: "#1a1a1a",
          // backgroundImage: `url(${dialogBgImage})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          // objectFit: "cover",
          // backgroundPosition: isTabletOrMobile && "bottom",
        }}
      >
        <DialogTitle sx={{}}>
          <MDBox sx={{ marginBottom: "2rem", textAlign: "right" }}>
            <IconButton onClick={onClose} color="white" fontSize="30px">
              <CloseIcon />
            </IconButton>
          </MDBox>
          <MDBox sx={{ textAlign: "center" }}>
            <MDTypography>Available Balance</MDTypography>
            <MDTypography color="singh">{balance} Singh</MDTypography>
          </MDBox>
        </DialogTitle>
        <Divider sx={{ margin: 0 }} />
        <DialogContent sx={{}}>
          <MDBox sx={{ textAlign: "center" }}>
            <MDTypography>Connected Wallet Address</MDTypography>
          </MDBox>
          <MDBox
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              border: "1px solid #F2CB2E",
              padding: "1rem",
              borderRadius: "20px",
            }}
          >
            <MDBox
              sx={{
                width: isTabletOrMobile ? "230px" : "400px",
              }}
            >
              <MDTypography
                sx={{ overflowWrap: "break-word" }}
                // overflow="hidden"
                // textOverflow="ellipsis"
                // whiteSpace="nowrap"
                fontSize="15px"
                color="singh"
              >
                {address}
              </MDTypography>
            </MDBox>
            <MDBox>
              <CopyToClipboard text={address}>
                <MDButton size="small" color="singh">
                  Copy
                </MDButton>
              </CopyToClipboard>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <MDBox>
            <MDButton
              variant="outlined"
              color="singh"
              onClick={handleWalletDisconnect}
            >
              Disconnect Wallet
            </MDButton>
          </MDBox>
        </DialogActions>
      </MDBox>
    </Dialog>
  );
}

export default WalletDialog;
